import React, { useEffect, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapIcon from '../../../services/TapIcon';
import AssetMiniDetail from '../../includes/ui/AssetMiniDetail';
import HttpAPICall from '../../../services/HttpAPICall';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';

const ChangeAssetCounterLogMeter = (props) => {

    const access_token              = useSelector(state => state.auth.access_token);

    const [searchedAssetCounterLog, setSearchedAssetCounterLog]     = useState([]);
    const [saveFormSubmitting, setSaveFormSubmitting]               = useState(false);
    const [assetDetails, setAssetDetails]                           = useState(null);
    const [loadingDetails, setLoadingDetails]                       = useState(false);
    const [meters, setMeters]                                       = useState([]);

    const tapSelectChange = (selectedOptions) => {
        if (!selectedOptions) {
            setSearchedAssetCounterLog([]);
            setAssetDetails(null);
            setMeters([]);
            return;
        }
        const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
        setSearchedAssetCounterLog(optionsArray);
        if (optionsArray.length > 0) {
            fetchAssetDetails(optionsArray[0].value);
        }
    };

    const fetchAssetDetails = (assetId) => {
        setLoadingDetails(true);
        const params = {
            master_id: props.master_id,
            asset_id: assetId,
            include_meters: 'Y'
        };

        HttpAPICall.withAthorization( 'GET', process.env.REACT_APP_SERVER_PATH + '/backoffice/group/asset/detail',
            access_token,params,{}, (resp) => {
                setAssetDetails(resp.data);
                setMeters(resp.data.meters.map(meter => ({ ...meter })));
                setLoadingDetails(false);
            }, (error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER })
                setLoadingDetails(false);
            }
        );
    };

    const handleInputChange = (index, field, value) => {
        const updatedMeters = [...meters];
        updatedMeters[index] = {
            ...updatedMeters[index],
            [field]: value
        };
        setMeters(updatedMeters);
    };

    const handleCheckboxChange = (index) => {
        const updatedMeters = [...meters];
        updatedMeters[index] = {
            ...updatedMeters[index],
            active: updatedMeters[index].active === "Y" ? "N" : "Y"
        };
        setMeters(updatedMeters);
    };

    const SaveData = (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true);
        const params = {
            master_id: props.master_id,
            asset_id: assetDetails.id,
            meters: meters.map(meter => ({
                key: meter.key,
                asset_label: meter.asset_label || "",
                label: meter.label || "",
                active: meter.active,
                max_running: meter.max_running || null,
                unit: meter.unit || null
            }))
        };
        HttpAPICall.withAthorization('PUT', process.env.REACT_APP_SERVER_PATH + '/backoffice/group/asset/change_meter', access_token, {}, params, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            fetchAssetDetails(assetDetails.id)
        }).then(() => {
              setSaveFormSubmitting(false);
        });
    };

    return (
        <>
            <Helmet>
                <title>Change Asset Counter Log Meter</title>
            </Helmet>
            <section>
                <form onSubmit={SaveData} className='py-4'>
                    <div className="row align-items-center py-2 mx-5 justify-content-center">
                        <label className="col-sm-2 form-label">Asset</label>
                        <div className="col-sm-6">
                            <InputAssetSearch
                                fontSize="93%"
                                placeholder="Select Asset"
                                changeEvent={tapSelectChange}
                                isClearable={true}
                                master_id={props.master_id}
                                value={searchedAssetCounterLog}
                            />
                            {loadingDetails && <Loader />}
                        </div>
                    </div>
                    {assetDetails && (
                        <div className="row align-items-center justify-content-center mx-5">
                            <div className="offset-4 col-sm-8">
                                <AssetMiniDetail assetDetail={[{ data: assetDetails }]} />
                            </div>
                        </div>
                    )}

                    {meters.length > 0 && (
                        <div className="mt-3 px-4 ">
                            <h6>Available Meters</h6>
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th className='text-center' style={{ width: "3%" }}>#</th>
                                            <th style={{ width: "15%" }}>Label</th>
                                            <th style={{ width: "15%" }}>Original Name</th>
                                            <th style={{ width: "10%" }}>Limit</th>
                                            <th style={{ width: "10%" }}>Unit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {meters.map((meter, index) => (
                                            <tr key={index}>
                                                <td className='text-center'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={meter.active === "Y"}
                                                        onChange={() => handleCheckboxChange(index)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.asset_label || ""}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => handleInputChange(index, 'asset_label', e.target.value)}
                                                        disabled={meter.active === "N"}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.label}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        disabled
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={meter.max_running || ""}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => handleInputChange(index, 'max_running', e.target.value)}
                                                        disabled={meter.active === "N" || meter.unit === "Hr"}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.unit}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    <div className="d-flex py-2 mx-5 align-items-end justify-content-end mt-4">
                        <button
                            type="submit"
                            disabled={saveFormSubmitting || !assetDetails}
                            className="btn btn-primary"
                        >
                            Save
                            {saveFormSubmitting && (
                                <span className="ms-2">
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                </span>
                            )}
                        </button>
                    </div>
                </form>
            </section>
        </>
    );
};

export default ChangeAssetCounterLogMeter;